import type { FC } from "react";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { minVisitsAbbrFilter } from "app/filters/ngFilters";

import type { Keyword } from "../types";

export const Volume: FC<{ keyword: Keyword }> = ({ keyword }) => {
    const { volume, isLoading } = keyword;
    const formattedVolume = minVisitsAbbrFilter()(volume, 0);
    return isLoading ? (
        <PixelPlaceholderLoader
            width={"60px"}
            height={"20px"}
        />
    ) : (
        <span>{formattedVolume}</span>
    );
};
